// @ts-check
import { MainProvider } from "./MainContext";
import Cabeza from "./subcomp/Cabeza";
import SideBar from "./subcomp/SideBar";
import Drawer from "./subcomp/Drawer";
import Pies from "./subcomp/Pies";
import Listado from "./subcomp/Listado";
import Dialog from "./subcomp/Dialog";

import "./Main.scss";

function MainContent() {
  return (
    <div id="Main">
      <Cabeza />
      <SideBar />
      <Drawer />
      <Pies />
      <Listado />
      <Dialog />
    </div>
  );
}

function Main() {
  return (
    <MainProvider>
      <MainContent />
    </MainProvider>
  );
}

export default Main;
